export default __webpack_public_path__ + "static/media/Ka-Pusement's Token.f858f3ba.jpg";